import AuthMethods from './AuthMethods'

export default AuthMethods
